import React from 'react';
import { StickyScrollDemo } from './demo';

const ProductDemo: React.FC = () => {
  // StickyScrollDemo is already responsive - uses flex-col on mobile, lg:flex-row on desktop
  return <StickyScrollDemo />;
};

export default ProductDemo;
